module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "projects"
  }, [_c('h3', [_vm._v("Projects")]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "project-item"
  }, [_c('p', {
    staticClass: "project-title"
  }, [_vm._v("Microservices")]), _vm._v(" "), _c('p', {
    staticClass: "project-desc"
  }, [_vm._v("Development of MAP (Media Application Platform) using suite of AWS services")]), _vm._v(" "), _c('p', {
    staticClass: "project-desc"
  }, [_vm._v("(AWS - Lambda, API Gateway, S3, DynamoDB, Cognito, SNS, Cloudfront).")])]), _vm._v(" "), _c('div', {
    staticClass: "project-item"
  }, [_c('p', {
    staticClass: "project-title"
  }, [_vm._v("Emoji CMS")]), _vm._v(" "), _c('p', {
    staticClass: "project-desc"
  }, [_vm._v("Managing and developing the CMS that supports the Emoji business that includes Container apps, sticker packs and keyboard extensions on iOS platform")]), _vm._v(" "), _c('p', {
    staticClass: "project-desc"
  }, [_vm._v("(1M+ downloads and 100k+ daily active users)")])]), _vm._v(" "), _c('div', {
    staticClass: "project-item"
  }, [_c('p', {
    staticClass: "project-title"
  }, [_vm._v("Stoopidland")]), _vm._v(" "), _c('p', {
    staticClass: "project-desc"
  }, [_vm._v("Lead the development of Container, Keyboard extension and Sticker extension for the Stoopidland Project")]), _vm._v(" "), _c('p', {
    staticClass: "project-desc"
  }, [_vm._v("(Swift, Realm, In-app purchases, configs, analytics)")])]), _vm._v(" "), _c('div', {
    staticClass: "project-item"
  }, [_c('a', {
    staticClass: "project-title",
    attrs: {
      "href": "http://ehow.com",
      "target": "_blank"
    }
  }, [_vm._v("eHow")]), _vm._v(" "), _c('p', {
    staticClass: "project-desc"
  }, [_vm._v("DIY site getting 75 Million+ visits/month")]), _vm._v(" "), _c('p', {
    staticClass: "project-desc"
  }, [_vm._v("(Javascript, NodeJS, Firebase, React, Redux, EmberJS, New Relic)")])]), _vm._v(" "), _c('div', {
    staticClass: "project-item"
  }, [_c('a', {
    staticClass: "project-title",
    attrs: {
      "href": "http://techwalla.com/",
      "target": "_blank"
    }
  }, [_vm._v("Techwalla")]), _vm._v(" "), _c('p', {
    staticClass: "project-desc"
  }, [_vm._v("Tech review site that provides metacritic data")]), _vm._v(" "), _c('p', {
    staticClass: "project-desc"
  }, [_vm._v("Lead the development of UI/UX on the site")])]), _vm._v(" "), _c('div', {
    staticClass: "project-item"
  }, [_c('a', {
    staticClass: "project-title",
    attrs: {
      "href": "https://animeshmanglik.name/",
      "target": "_blank"
    }
  }, [_vm._v("animeshmanglik.name")]), _vm._v(" "), _c('p', {
    staticClass: "project-desc"
  }, [_vm._v("Resume TL; DR")]), _vm._v(" "), _c('p', {
    staticClass: "project-desc"
  }, [_vm._v("(VueJS, AWS, NodeJS)")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-cb7c223c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/sections/Projects.vue
// module id = 60
// module chunks = 0